<template>
    <section class="slice slice-trends-quote" :class="{'slice-trends-quote--grey': backgroundColor === 'grey'}">
        <div class="slice-content">
            <TitleBrand :field="props.slice.primary.title" class="slice-trends-quote__title" />

            <div class="slice-trends-quote__quote">
                <svg width="66" height="53" viewBox="0 0 66 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M31.0256 0.902219L28.7692 8.04752C17.4872 4.85093 7.7094 14.6287 7.89744 28.1672C18.4274 23.2783 27.641 30.2356 27.641 39.2612C27.641 46.9706 22 52.4236 14.6667 52.4236C6.01709 52.4236 0 45.2783 0 30.9877C0 9.17572 13.1624 -3.6106 31.0256 0.902219ZM66 0.902219L63.9316 8.04752C52.4615 4.85093 42.8718 14.6287 42.8718 28.1672C53.5897 23.2783 62.6154 30.2356 62.6154 39.2612C62.6154 46.9706 57.1624 52.4236 49.641 52.4236C41.1795 52.4236 35.1624 45.2783 35.1624 30.9877C35.1624 9.17572 48.1368 -3.6106 66 0.902219Z"
                        fill="#FF5C57"
                    />
                </svg>
                <PrismicRichText :field="props.slice.primary.quote" data-testid="slice-trends-quote" />
                <div class="slice-trends-quote__author-wrapper">
                    <div class="slice-trends-quote__author">
                        <div data-testid="slice-trends-quote-author">{{ props.slice.primary.author }}</div>
                        <div data-testid="slice-trends-quote-author-job">{{ props.slice.primary.authorJob }}</div>
                    </div>
                    <div class="slice-trends-quote__image-wrapper">
                        <MktCardHandAdaptive v-if="props.slice.primary.image" brand-theme>
                            <PrismicImage :field="props.slice.primary.image" />
                        </MktCardHandAdaptive>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {Content} from '@prismicio/client';
    import {getSliceComponentProps, PrismicImage, PrismicRichText} from '@prismicio/vue';
    import {MktCardHandAdaptive} from '#components';
    import TitleBrand from '~/components/TitleBrand.vue';

    const props = defineProps(getSliceComponentProps<Content.TrendsQuoteSlice>(['slice', 'index', 'slices', 'context']));
    const backgroundColor = computed(() => props.slice.primary.backgroundColor);
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    .slice-trends-quote {
        &--grey {
            background-color: var(--joy-color-neutral-20);
        }

        .slice-content {
            @include mq.screen_md(min) {
                padding-left: 120px;
                padding-right: 120px;
            }
        }

        &__title {
            margin-bottom: var(--joy-core-spacing-9);

            @include mq.screen_md(min) {
                text-align: center;
                margin-bottom: var(--joy-core-spacing-6);
            }
        }

        &__quote {
            background-color: var(--joy-color-neutral-20);
            padding: var(--joy-core-spacing-9) var(--joy-core-spacing-4);
            border-radius: var(--joy-core-radius-4);

            p {
                font-size: var(--joy-font-size-primary-600);
                font-family: var(--joy-font-family-title);
                line-height: 30px;
            }

            svg {
                margin-bottom: var(--joy-core-spacing-6);
                align-self: flex-start;
                flex: none;
            }

            @include mq.screen_md(min) {
                display: flex;
                align-items: center;
                padding: var(--joy-core-spacing-9) var(--joy-core-spacing-8);
                gap: var(--joy-core-spacing-9);
            }
        }

        &__image-wrapper {
            width: 80px;

            @include mq.screen_md(min) {
                width: 145px;
                margin-left: auto;
            }
        }

        &__author-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: var(--joy-core-spacing-6);
            gap: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                flex-direction: column-reverse;
                text-align: left;
                margin-top: initial;
            }
        }

        &__author {
            text-align: right;
            line-height: var(--joy-line-height-large);

            :first-child {
                font-size: var(--joy-font-size-primary-400);
                font-family: var(--joy-font-family-title);
            }
            :last-child {
                width: 200px;
                font-size: var(--joy-font-size-primary-300);
            }
        }
    }
</style>
